export default __webpack_public_path__ + "static/CenturyGothic-Regular-43d7fa24909560242e48a6679cfa5e11.ttf";